<app-ace-select
  #aceSelect
  [ngbTooltip]="(selectedTasks?.length > MAX_ITEMS) && tipContent"
  container="body"
  placement="right"
  [items]="tasks"
  [multiSelect]="multiSelect"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [placeholder]="placeholder"
  [loading]="loading"
  [compareWith]="compareFn"
  [hideSelected]="hideSelected"
  [appendTo]="appendTo">

  @if (!multiSelect) {
    <ng-template #labelTemplate let-item="item" let-clear="clear">
      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
      <span class="ng-value-label" title="{{item.template.template_name}} {{item.task_id}}">{{item.template.template_name}} {{item.task_id}}</span>
    </ng-template>
  } @else {
    <ng-template #multiLabelTemplate let-items="items" let-clear="clear">
      @if (items.length <= MAX_ITEMS) {
        <div>
          @for (item of items; track item.task_id) {
            <div class="ng-value">
              <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label" title="{{item.template.template_name}} {{item.task_id}}">{{item.template.template_name}} {{item.task_id}}</span>
            </div>
          }
        </div>
      } @else {
        <div>
          <div class="ng-value">
            <span class="ng-value-label">{{items.length}} tasks selected</span>
          </div>
        </div>
      }
    </ng-template>
  }

  <ng-template #optionTemplate let-item="item">
    <span class="ng-value-label" title="{{item.template.template_name}} {{item.task_id}}">{{item.template.template_name}} {{item.task_id}}</span>
  </ng-template>

  <ng-template #tipContent>
    <table class="cim-tooltip">
      @for (item of selectedTasks; track item.task_id) {
        <tr>
          <td>{{item.template.template_name}} {{item.task_id}}</td>
        </tr>
      }
    </table>
  </ng-template>

</app-ace-select>
